import { Avatar, Button, Grid, Paper, Snackbar, TextField } from '@mui/material';
import { Visibility, VisibilityOff  } from '@mui/icons-material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Alert, IconButton, InputAdornment } from '@mui/material';
import React, { useState } from 'react';
import ApiServices from '../services/ApiServices';

const LoginPage = (props) => {

    const paperStyle = { padding: 20, width: 280, margin: "10% auto" }
    const avatarStyle = { backgroundColor: '#1bbd7e' }
    const btnstyle = { margin: '8px 0' }
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [emailError, setEmailError] = useState('');
    const [alertObj, setAlertObj] = React.useState({ open: false, severity: "error", message: "" });
    const [showPassword, setShowPassword] = useState(false);

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    }

    const handlePasswordChange = (event) => {
        setPassword(event.target.value)
    }

    const handleClose = () => {
        setAlertObj({ open: false });
    };

    const handleFormSubmit = (e) => {
        e.preventDefault()
        setEmailError('');
        if (validateEmail(email)) {
            const loginRequest = { 'username': email, 'password': password };
            ApiServices.login(loginRequest)
                .then(response => {
                    if (response.status === 200 && response.data.token) {
                        localStorage.setItem('jwt_token', response.data.token);
                        setAlertObj({ open: true, severity: "success", message: "Logged in successfully." })
                        props.loginSuccess();
                    }

                })
                .catch(error => {
                    console.error(error);                    
                    setAlertObj({ open: true, severity: "error", message: error.response?.data ?? error.message })
                });
        } else {
            setEmailError("Invalid email address.")
        }
    }

    const validateEmail = (email) => {
        let result = true;

        if (email) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            result = re.test(String(email).toLowerCase());
        }

        return result;
    }

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword)
    };

    const handleMouseDownPassword = () => {
        setShowPassword(!showPassword)
    };

    return (
        <Grid>
            <Paper elevation={10} style={paperStyle}>
                <form onSubmit={handleFormSubmit}>
                    <Grid
                        container
                        spacing={2}
                        direction={'column'}
                        justifyContent={'center'}
                        alignItems={'center'}
                    >
                        <Grid align='center'>
                            <Avatar style={avatarStyle}><LockOutlinedIcon /></Avatar>
                            <h2>Sign In</h2>
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                label='Email'
                                placeholder='Enter email'
                                variant="outlined"
                                value={email}
                                error={emailError ? true : false}
                                helperText={emailError}
                                onChange={handleEmailChange}
                                fullWidth
                                required />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                label='Password'
                                placeholder='Enter password'
                                type={showPassword ? "text" : "password"}
                                variant="outlined"
                                value={password}
                                onChange={handlePasswordChange}
                                fullWidth
                                required
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                            >
                                                {showPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }} 
                                />
                        </Grid>
                        <Grid item xs={12}>
                            <Button type='submit' color='primary' variant="contained" style={btnstyle} fullWidth >Login</Button>
                        </Grid>

                    </Grid>
                </form>
            </Paper>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                autoHideDuration={2000}
                open={alertObj.open}
                onClose={handleClose}
            >
                <Alert severity={alertObj.severity} sx={{ width: '100%' }}>
                    {alertObj.message}
                </Alert>
            </Snackbar>
        </Grid>
    )
}

export default LoginPage